import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { AllHtmlEntities } from 'html-entities';
import { routeFromType, iconFromType } from '../../helpers/notificationHelpers';
import { Icon } from './sidebarNotification.style';
import Styles from './notificationStyle';

const entities = new AllHtmlEntities();
const regex = /(<([^>]+)>)/ig;

class Notification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hovering: false,
    }

    this.onClick = this.onClick.bind(this);
    this.onEnter = this.onEnter.bind(this);
    this.onLeave = this.onLeave.bind(this);
  }

  onClick = () => {
    const route = routeFromType(this.props.data.type, this.props.data.contextData);
    if (route) {
      this.props.closeDrawer();
      this.props.history.push(route);
    }
  }

  onEnter = () => {
    this.setState({ hovering: true });
  }

  onLeave = () => {
    this.setState({ hovering: false });
  }

  render() {
    const { data } = this.props;
    const momentDate = new moment(data.ts);
    const date = momentDate.format("DD/MM/YY, h:mma");
    const messageToOutput = entities.decode(data.message).replace(regex, '');
    return (
      <Styles.Card elevation={this.state.hovering ? 2 : 1} key={data.id} onClick={this.onClick} onMouseEnter={this.onEnter} onMouseLeave={this.onLeave}>
        <Styles.MetaSection>
          <Styles.Avatar compulsory={data.compulsoryAction}>
            <Icon>{iconFromType(data.type, data.contextData)}</Icon>
          </Styles.Avatar>
          <Styles.MetaText>
            <Styles.Title variant="h6">{data.title}</Styles.Title>
            <Styles.Date className="date">{date}</Styles.Date>
          </Styles.MetaText>
        </Styles.MetaSection>
  
        <Styles.Content className="listContent">
          <Styles.Message variant="h6">{messageToOutput}</Styles.Message>
        </Styles.Content>
      </Styles.Card>
    );
  }
}

export default withRouter(Notification);


// WEBPACK FOOTER //
// ./src/containers/Topbar/notification.js